export const crapienv: {
  IDENTITY_SERVICE: string;
  WORKSHOP_SERVICE: string;
  CHATBOT_SERVICE: string;
  COMMUNITY_SERVICE: string;
} = {
  IDENTITY_SERVICE: "/crapi/identity/",
  WORKSHOP_SERVICE: "/crapi/workshop/",
  CHATBOT_SERVICE: "/crapi/chatbot/",
  COMMUNITY_SERVICE: "/crapi/community/",
};
